import { useEffect, useRef, useState } from 'react';
// import Popup from 'reactjs-popup';
import { Markup } from 'interweave';

import Title from '../shared/Title';
import './GameSpace.css';
import Description from '../shared/Description';
import backGroundCuriculum from '../../assets/images/curriculum/Background_Chuong_trinh_dao_tao.png';
// import ContentModal from '../shared/PopUpModal';

import { apispreadsheets, imgFromDriveUrl } from '../shared/ApiSpreadSheets';

import { SHEET_NAMES } from '../../constants/sheets';


function GameSpace() {
    const [menuCurrent, setMenuCurrent] = useState(0);
    const animationConfig = { animationName: 'curriculumDetail', animationDuration: '0.6s', timeout: 1000 };

    const [effectCurriculumDetailDuration, setEffectCurriculumDetailDuration] = useState(
        `${animationConfig.animationName} ${animationConfig.animationDuration}`,
    );

    // Check is Mobile
    const [isMobile, setIsMobile] = useState(window.innerWidth < 845);
    const isMobileController = () => {
        setIsMobile(window.innerWidth < 1280);
    };
    // const exceptionHeightSrceen = () => {
    //   if (window.innerHeight >= 905) {
    //     bgShortDescription.current.style.backgroundSize = "cover";
    //   } else {
    //     bgShortDescription.current.style.backgroundSize = "";
    //   }
    // };

    useEffect(() => {
        // exceptionHeightSrceen();
        window.addEventListener('resize', isMobileController);
        // window.addEventListener('resize', exceptionHeightSrceen);

        return () => {
            window.removeEventListener('resize', isMobileController);
            // window.removeEventListener('resize', exceptionHeightSrceen);
        };
    }, []);

    const [isLoaded, setIsLoaded] = useState(false);
    const [sheets, setSheets] = useState([]);
    // const bgShortDescription = useRef();

    // const NGANH_2_MOCK = {
    //   chuong_trinh: "Ngành 2",
    //   mo_ta: "Nội dung ngành 2 đang được cập nhật",
    //   hoc_ky: "Học kỳ 1",
    //   anh_project1: "",
    //   isMock: true,
    // };

    function normalizeCurriculumData(rows) {
        const result = [];
        let currentProgram = null;

        rows.forEach(row => {
            // Gặp dòng có tên ngành → tạo chương trình mới
            if (row.nganh && row.nganh.trim() !== "") {
                currentProgram = {
                    ten_chuong_trinh: "Ngành " + row.nganh,
                    mo_ta: row.mo_ta || "",
                    hoc_ky_list: [],
                };
                // console.log(currentProgram);
                result.push(currentProgram);
            }

            // Gặp dòng học kỳ → nhét vào chương trình hiện tại
            if (currentProgram && row.hoc_ky) {
                currentProgram.hoc_ky_list.push({
                    hoc_ky: row.hoc_ky,
                    anh_project1: row.anh_project1 || "",
                    anh_project2: row.anh_project2 || "",
                    tieu_de_gioi_thieu_ngan: row.tieu_de_gioi_thieu_ngan || "",
                });
                // console.log(currentProgram);
            }
        });

        return result;
    }


    // FETCH DATA AND SET STATUS
    useEffect(() => {
        const sheetName = SHEET_NAMES.CHUONG_TRINH_DAO_TAO;
        fetch(`${apispreadsheets}/${sheetName}`)
            .then((res) => res.json())
            .then(
                (results) => {
                    const normalized = normalizeCurriculumData(results);
                    setSheets(normalized);
                    setIsLoaded(true);
                },
                (error) => {
                    console.log('error: ', error);
                    setIsLoaded(false);
                },
            );
    }, []);

    // WHEN CLICK FUNCTION HANDLE GetDataCuriculum
    const handleGetDataCuriculum = (index) => {
        setMenuCurrent(index);

        if (!isMobile) {
            setEffectCurriculumDetailDuration(`${animationConfig.animationName} ${animationConfig.animationDuration}`);
            setTimeout(() => {
                setEffectCurriculumDetailDuration('none');
            }, animationConfig.timeout);
        }
    };

    // const contentStyle = {
    //     maxWidth: '900px',
    //     width: '95%',
    // };


    // state cho chương trình đang chọn
    const [programCurrent, setProgramCurrent] = useState(1); // 1 là ngành thứ 2
    const [semesterCurrent, setSemesterCurrent] = useState(0);

    useEffect(() => {
        if (sheets.length > 1) {
            setProgramCurrent(1); // ưu tiên ngành 2
            setSemesterCurrent(0); // học kỳ đầu
        }
    }, [sheets]);

    return (
        <>
            <div className="w-[100%] h-[1280px] xl:h-[1380px] relative">
                <div
                    className="w-[100%] bg-gamespace bg-auto md:bg-cover bg-no-repeat"
                    style={{ backgroundImage: `url(${backGroundCuriculum})` }}
                >
                    <div className="relative px-5 xl:px-80">
                        <Title className="mt-48 md:mt-[400px] lg:mt-[420px] text-center">Chương trình đào tạo</Title>

                        {/* <Description className="mt-5 text-justify md:text-center font-medium">
                        <Markup
                            allowAttributes
                            content={isLoaded && sheets[0].hoc_ky_list[0].mo_ta}
                        />
                        </Description> */}
                        <div className="flex justify-center mt-6 gap-8">
                            {sheets[programCurrent] && (
                                <h3 className="text-[#723091] md:text-2xl font-bold uppercase">
                                    {sheets[programCurrent].ten_chuong_trinh}
                                </h3>
                            )}
                        </div>

                        <div className="mt-5 text-justify md:text-center font-medium">
                            <Markup
                                allowAttributes
                                content={isLoaded ? sheets[programCurrent].mo_ta : ''}
                            />
                        </div>

                        {/* Begin Tab Menu */}
                        <div className="flex max-w-[70%] mx-auto text-white mt-4 justify-center cursor-pointer">
                            {sheets.map((data, index) => (
                                <div
                                    key={index}
                                    className={`mr-5 md:mr-6 min-w-fit ${menuCurrent == index ? 'menu-active' : ''}`}
                                    onClick={() => handleGetDataCuriculum(index)}
                                >
                                    {data.hoc_ky}
                                </div>
                            ))}
                        </div>

                        {/* End Tab Menu */}
                    </div>

                    <div className="flex max-w-[70%] mx-auto text-black mt-4 justify-center cursor-pointer">
                        {sheets[programCurrent]?.hoc_ky_list?.map((hocKy, index) => (
                            <div
                                key={index}
                                className={`mr-5 md:mr-6 min-w-fit ${semesterCurrent === index ? "menu-active" : ""
                                    }`}
                                onClick={() => setSemesterCurrent(index)}
                            >
                                {hocKy.hoc_ky}
                            </div>
                        ))}
                    </div>

                    {/* BEGIN CONTENT CURRICULUM */}
                    <div className="mt-5 sm:mt-6">
                        {isLoaded && (
                            <div className="flex justify-center">
                                <img
                                    className="content__img"
                                    src={imgFromDriveUrl(
                                        sheets[programCurrent]
                                            ?.hoc_ky_list[semesterCurrent]
                                            ?.anh_project1
                                    )}
                                    alt=""
                                />
                            </div>
                        )}
                    </div>

                </div>
            </div >


        </>
    );
}

export default GameSpace;
